import { styled } from '@linaria/react'
import { font } from '@reapit/elements/utils/font'

export const PageNotFoundContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-6, 24px);
`

export const PageNotFoundMessagesContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: var(--spacing-2, 8px);
`

export const PageNotFoundTitle = styled.h1`
  ${font('2xl', 'bold')}
`

export const PageNotFoundDescription = styled.p`
  ${font('base', 'regular')}
`
